/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Contact_DescriptionInputs */

const en_meta_contact_description = /** @type {(inputs: Meta_Contact_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact us to discover how to listen to academic papers, books, and PDFs on the go. Get started and explore innovative learning methods today!`)
};

const es_meta_contact_description = /** @type {(inputs: Meta_Contact_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contáctanos para descubrir cómo escuchar artículos académicos, libros y PDFs donde quieras. ¡Comienza y explora métodos de aprendizaje innovadores hoy!`)
};

/**
* | output |
* | --- |
* | "Contact us to discover how to listen to academic papers, books, and PDFs on the go. Get started and explore innovative learning methods today!" |
*
* @param {Meta_Contact_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_contact_description = /** @type {((inputs?: Meta_Contact_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Contact_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_contact_description(inputs)
	return en_meta_contact_description(inputs)
});